module.exports = __webpack_public_path__ + "img/flicker_green2.9f7e7ee5.gif";